<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="title">
      <h1>分科会参加者一覧</h1>
    </div>
    <!-- 検索条件入力 -->
    <div class="search-form-area" [formGroup]="f171SearchForm">
      <div class="p-d-flex p-jc-between item-div">
        <div class="p-d-flex p-jc-left">
          <!-- 検索テキスト -->
          <!-- 年度 -->
          <div class="item">
            <label class="label-space">年度</label>
            <p-dropdown [options]="yearList" optionLabel="sp_name" optionValue="sp_code" placeholder="全て"
              [showClear]="true" styleClass="information-Form-dropdown" formControlName="year"></p-dropdown>
          </div>
          <!-- 提案テーマ -->
          <div class="item">
            <label class="label-space">提案テーマ</label>
            <input type="text" pInputText placeholder="" formControlName="title"/>
          </div>
          <!-- 設置団体名称 -->
          <div class="item">
            <label class="label-space">設置団体名称</label>
            <input type="text" pInputText placeholder="" formControlName="create_organization_name"/>
          </div>
        </div>
        <div class="p-d-flex p-jc-right button-div">
          <!-- CSVボタン -->
          <button pButton type="button" label="CSV" class="p-mr-2" (click)="exportCSV()"></button>
          <div class="button-space"></div>
          <!-- 検索ボタン -->
          <button pButton type="button" label="検索" class="button1 search-button" (click)="getSearchResultsList()"></button>
        </div>
      </div>
    </div>

    <!-- 結果表示 -->
    <div class="result-area">
      <!-- ページアンカー -->
      <a id="jump-top"></a>
      <!-- 検索結果数 -->
      <div class="result-count-area">
        <label class="count"> {{ searchResultsList.length }} </label>
        件
      </div>
      <!-- リスト表示 -->
      <p-table
        #table
        [value]="searchResultsList"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first}~{last}件表示({totalRecords}件中)"
        [rowsPerPageOptions]="[10, 50, 100, 500, 1000]"
        emptyMessage="データが存在しません"
        styleClass="p-datatable-striped master-datatable"
        selectionMode="single"
        [scrollable]="true"
        scrollHeight="460px"
  
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="no" pSortableColumn="no">
              No. <p-sortIcon field="no"></p-sortIcon>
            </th>
            <th class="theme" pSortableColumn="theme">
              提案テーマ <p-sortIcon field="theme"></p-sortIcon>
            </th>
            <th class="organization_name" pSortableColumn="organization_name">
              設置団体名 <p-sortIcon field="organization_name"></p-sortIcon>
            </th>
            <th class="full_name" pSortableColumn="full_name">
              氏名 <p-sortIcon field="full_name"></p-sortIcon>
            </th>
            <th class="organizer_group_name" pSortableColumn="organizer_group_name">
              団体名称 <p-sortIcon field="organizer_group_name"></p-sortIcon>
            </th>
            <th class="user_kbn" pSortableColumn="user_kbn.id">
              メンバー区分 <p-sortIcon field="user_kbn"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-searchResultsList>
          <tr >
            <!-- No -->
            <td class="no-data">{{ searchResultsList?.no }}</td>
            <!-- 分科会タイトル -->
            <td class="theme-data">{{ searchResultsList?.theme }}</td>
            <!-- 設置団体名 -->
            <td>{{ searchResultsList?.organization_name }}</td>
            <!-- 氏名 -->
            <td>{{ searchResultsList?.full_name }}</td>
            <!-- 団体名 -->
            <td>{{ searchResultsList?.organizer_group_name }}</td>
            <!-- メンバー区分 -->
            <td>{{ searchResultsList?.user_kbn.name }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>